<div>
  <app-mat-spinner-overlay *ngIf="showSpinner"></app-mat-spinner-overlay>

  <mat-tab-group class="loan_tab" [selectedIndex]="selectedTabIndex" (selectedTabChange)="onTabChange($event)">
    <mat-tab>
      <ng-template mat-tab-label><span>Queries Raised</span></ng-template>
    </mat-tab>
    <mat-tab>
      <ng-template mat-tab-label><span>Queries Received</span></ng-template>
    </mat-tab>
  </mat-tab-group>

  <div class="filter-card">
    <div class="row m-0 align-items-center">
      <div class="col-md-2 p-1">
        <span class="filter-label">From Date</span>
        <div class="datepicker_feild">
          <input [matDatepicker]="pickerFrom" dateConvert placeholder="DD/MM/YYYY" name="FromDate" id="FromDate"
            class="form-control input-text-css" [(ngModel)]="FromDate" (dateChange)="DateChange()" />
          <mat-datepicker-toggle matSuffix [for]="pickerFrom"></mat-datepicker-toggle>
          <mat-datepicker #pickerFrom></mat-datepicker>
        </div>
      </div>

      <div class="col-md-2 p-1">
        <span class="filter-label">To Date</span>
        <div class="datepicker_feild">
          <input [matDatepicker]="pickerTo" dateConvert placeholder="DD/MM/YYYY" name="ToDate" id="ToDate"
            class="form-control input-text-css" [(ngModel)]="ToDate" (dateChange)="DateChange()" />
          <mat-datepicker-toggle matSuffix [for]="pickerTo"></mat-datepicker-toggle>
          <mat-datepicker #pickerTo></mat-datepicker>
        </div>
      </div>

      <div class="col-md-2 p-1">
        <span class="filter-label">Status</span>
        <select name="Status" id="Status" [(ngModel)]="Status" (change)="onFilterChange()"
          class="form-control input-text-css">
          <option value="All">All</option>
          <option value="Pending">Pending</option>
          <option value="Replied">Replied</option>
        </select>
      </div>

      <div class="col-md-2 p-1">
        <span class="filter-label">Priority</span>
        <select name="Priority" id="Priority" [(ngModel)]="Priority" (change)="onFilterChange()"
          class="form-control input-text-css">
          <option value="All">All</option>
          <option value="Low">Low</option>
          <option value="Medium">Medium</option>
          <option value="High">High</option>
        </select>
      </div>

      <div class="col-md-1 p-1 mt-2">
        <button type="button" (click)="Get_Internal_Query_Logs_List()" class="btn font-size-12 button-btn w-100">
          <i class="fa fa-search mr-1"></i>Search
        </button>
      </div>

      <div class="col-md-3 p-1 mt-2">
        <form action="" class="search-text" (submit)="$event.preventDefault()">
          <div class="search-pill">
            <i class="fa fa-search search-icon"></i>
            <input type="text" id="FilterInputSearch" (keyup)="applyFilter($event.target.value)"
              name="FilterInputSearch" placeholder="What're you searching for?" class="search-input" />
          </div>
        </form>
      </div>
    </div>
  </div>

  <div class="table-responsive mt-2 table-card">
    <mat-table [dataSource]="dataSource" matSort matTableExporter #exporter="matTableExporter">
      <ng-container matColumnDef="Index">
        <mat-header-cell mat-sort-header class="grid-header" style="max-width: 3.5rem" *matHeaderCellDef>
          #
        </mat-header-cell>
        <mat-cell *matCellDef="let row; let i = index" class="grid-cell" style="max-width: 3.5rem">
          {{ (paginatorRef?.pageIndex * paginatorRef?.pageSize) + (i + 1) }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="Application_No">
        <mat-header-cell mat-sort-header class="grid-header" *matHeaderCellDef> Application No </mat-header-cell>
        <mat-cell *matCellDef="let row" class="grid-cell">
          <a *ngIf="!isRepliedByToEmp(row)" href="javascript:void(0)" (click)="goToDetail(row)" class="app-no-link">
            {{ row.Application_No }}
          </a>
          <span *ngIf="isRepliedByToEmp(row)" class="text-muted font-weight-bold" title="Already Replied">
            {{ row.Application_No }}
          </span>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="From_EmpName">
        <mat-header-cell mat-sort-header class="grid-header" *matHeaderCellDef> From Employee </mat-header-cell>
        <mat-cell *matCellDef="let row" class="grid-cell">
          {{ row.From_EmpName }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="To_EmpName">
        <mat-header-cell mat-sort-header class="grid-header" *matHeaderCellDef> To Employee </mat-header-cell>
        <mat-cell *matCellDef="let row" class="grid-cell">
          {{ row.To_EmpName }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="From_Remark">
        <mat-header-cell mat-sort-header class="grid-header" *matHeaderCellDef> Query Remark </mat-header-cell>
        <mat-cell *matCellDef="let row" class="grid-cell">
          <span class="text-truncate-cell" [title]="row.From_Remark">{{ row.From_Remark }}</span>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="To_Remark">
        <mat-header-cell mat-sort-header class="grid-header" *matHeaderCellDef> Reply Remark </mat-header-cell>
        <mat-cell *matCellDef="let row" class="grid-cell">
          <span class="text-truncate-cell" [title]="row.To_Remark || row.ToRemark">{{ row.To_Remark || row.ToRemark ||
            '-' }}</span>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="Priority">
        <mat-header-cell mat-sort-header class="grid-header" *matHeaderCellDef> Priority </mat-header-cell>
        <mat-cell *matCellDef="let row" class="grid-cell">
          <span *ngIf="row.Priority === 'High'" class="priority-badge high">High</span>
          <span *ngIf="row.Priority === 'Medium'" class="priority-badge medium">Medium</span>
          <span *ngIf="row.Priority === 'Low'" class="priority-badge low">Low</span>
          <span
            *ngIf="!row.Priority || (row.Priority !== 'High' && row.Priority !== 'Medium' && row.Priority !== 'Low')">
            {{ row.Priority || '-' }}
          </span>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="Status">
        <mat-header-cell mat-sort-header class="grid-header" *matHeaderCellDef> Status </mat-header-cell>
        <mat-cell *matCellDef="let row" class="grid-cell">
          <span *ngIf="row.Status === 'Pending' || row.Status === 'P'" class="status-badge pending">
            <span class="status-dot"></span>Pending
          </span>
          <span *ngIf="row.Status === 'Replied' || row.Status === 'R' || row.Status === 'Completed'"
            class="status-badge replied">
            <span class="status-dot"></span>Replied
          </span>
          <span
            *ngIf="row.Status !== 'Pending' && row.Status !== 'P' && row.Status !== 'Replied' && row.Status !== 'R' && row.Status !== 'Completed'"
            class="status-badge default">{{ row.Status }}</span>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="Send_On">
        <mat-header-cell mat-sort-header class="grid-header" *matHeaderCellDef> Created Date </mat-header-cell>
        <mat-cell *matCellDef="let row" class="grid-cell">
          {{ row.Send_On || row.SendOn || row.CreatedDate }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="Reply_On">
        <mat-header-cell mat-sort-header class="grid-header" *matHeaderCellDef> Reply Date </mat-header-cell>
        <mat-cell *matCellDef="let row" class="grid-cell">
          {{ row.Reply_On || row.ReplyOn || row.To_Date || '-' }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="Docs">
        <mat-header-cell class="grid-header text-center" *matHeaderCellDef> Docs </mat-header-cell>
        <mat-cell *matCellDef="let row" class="grid-cell text-center">
          <button *ngIf="hasDocs(row.Id)" type="button" class="docs-btn" (click)="openQueryDocsModal(row)"
            title="View Documents">
            <i class="fa fa-eye"></i>
            <span class="docs-count">{{ getDocsForQuery(row.Id).length }}</span>
          </button>
          <span *ngIf="!hasDocs(row.Id)" class="text-muted">-</span>
        </mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
    </mat-table>

    <div class="row m-0 align-items-center">
      <div class="col-md-12">
        <mat-paginator #paginatorRef [pageSizeOptions]="[10, 20, 50]" showFirstLastButtons> </mat-paginator>
      </div>
    </div>
  </div>
</div>

<!-- Query Documents Modal -->
<div class="modal fade in" id="queryDocsModal" tabindex="-1" role="dialog" aria-labelledby="queryDocsModalLabel"
  aria-hidden="true" data-backdrop="false" style="background-color: rgba(15, 23, 42, 0.55);">
  <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
    <div class="modal-content border-0 shadow-lg docs-modal">
      <div class="modal-header docs-modal-header align-items-center">
        <h6 class="modal-title font-weight-bold mb-0 text-white" id="queryDocsModalLabel">
          <i class="fa fa-file-text-o mr-2"></i> Query Documents
          <span class="app-no-chip">{{ selectedQueryRow?.Application_No || '-' }}</span>
        </h6>
        <button type="button" class="close text-white" (click)="closeQueryDocsModal()" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body p-3">
        <div class="table-responsive" *ngIf="selectedQueryDocs && selectedQueryDocs.length > 0">
          <table class="table table-hover mb-0 docs-table">
            <thead>
              <tr>
                <th style="width: 50px;">#</th>
                <th>Type</th>
                <th>Doc Title</th>
                <th>Doc Path / Name</th>
                <th>Created On</th>
                <th class="text-center" style="width: 90px;">Action</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let doc of selectedQueryDocs; let i = index">
                <td>{{ i + 1 }}</td>
                <td>
                  <span class="comm-type-badge" [ngClass]="(doc.Communication_Type === 'Reply' || doc.CommunicationType === 'Reply') ? 'reply' : 'request'">
                    {{ doc.Communication_Type || doc.CommunicationType || 'Request' }}
                  </span>
                </td>
                <td class="font-weight-bold">{{ doc.Doc_Title || '-' }}</td>
                <td class="text-truncate" style="max-width: 220px;" [title]="doc.Doc_Path">{{ doc.Doc_Path || '-' }}
                </td>
                <td>{{ doc.CreatedOn || '-' }}</td>
                <td class="text-center">
                  <button type="button" class="btn btn-sm button-btn p-1 px-2" (click)="viewDocument(doc)"
                    title="Open in new tab">
                    <i class="fa fa-eye mr-1"></i> View
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div *ngIf="!selectedQueryDocs || selectedQueryDocs.length === 0" class="text-center py-4 text-muted">
          <i class="fa fa-folder-open-o fa-2x mb-2"></i>
          <p class="mb-0">No documents found for this query.</p>
        </div>
      </div>
      <div class="modal-footer p-2 px-3">
        <button type="button" class="btn btn-secondary btn-sm" (click)="closeQueryDocsModal()">Close</button>
      </div>
    </div>
  </div>
</div>